import { getScrollGutterPluginState } from '../plugin-key';
export var getKeyboardHeight = function getKeyboardHeight(state) {
  if (state) {
    var scrollGutterPluginState = getScrollGutterPluginState(state);
    return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
  }
};